// Phase 129 Plan 04 Task 1 — Card surface (DESIGN.md dark theme).
//
// Dark surface inverts the Meta Store light card pattern:
//   - bg #181A1B (Oculus-Light surface — slightly warmer than canvas #1C1E21)
//   - border white/10 for subtle separation against canvas
//   - 24px radius (feature card per DESIGN.md — 20px for standard cards)
//   - dual-shadow elevation pattern from DESIGN.md
import * as React from 'react';

import { cn } from '../../lib/utils';

export function Card({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={cn(
        'rounded-[24px] bg-[#181A1B] border border-white/10 shadow-[0_12px_28px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.1)]',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-header" className={cn('px-8 pt-8', className)} {...props} />;
}

export function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('px-8 pb-8', className)} {...props} />;
}
